import { Pipe, PipeTransform } from '@angular/core';
import { enumPaymentMethod } from '../utils/enum-payment-method';

@Pipe({ name: 'paymentMethod' })
export class PaymentMethodPipe implements PipeTransform {
  transform(value: string, ...args: boolean[]): string {
    switch (value) {
      case enumPaymentMethod.STRIPE_ADVANCE:
        return `<div class="badge-container pmethod inline text-xs line-height-1  stripe_adv">Carta di Credito/Altro</div>`;
      case enumPaymentMethod.STRIPE_TRANSFER:
        return `<div class="badge-container pmethod inline text-xs  line-height-1 stripe_adv">Carta di Credito/Altro</div>`;
      case enumPaymentMethod.BANK_TRANSFER_ADV:
        return `<div class="badge-container pmethod inline text-xs line-height-1 bank_trans">Bonifico</div>`;
      case enumPaymentMethod.BANK_TRANSFER_PAYOFF:
        return `<div class="badge-container pmethod inline text-xs  line-height-1 bank_trans">Bonifico</div>`;
      case enumPaymentMethod.SCALAPAY_TRANSFER:
        return `<div class="badge-container pmethod inline text-xs  line-height-1 scalapay_trans">Scalapay</div>`;
      case enumPaymentMethod.CASH_ADV:
        return `<div class="badge-container pmethod inline text-xs  line-height-1 cash_trans">Contanti</div>`;
      case enumPaymentMethod.CASH_PAYOFF:
        return `<div class="badge-container pmethod inline text-xs line-height-1 cash_trans">Contanti</div>`;
    }
    return ``;
  }
}
